import React from 'react'
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove';
import { NavLink, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ThemeContext } from '../../theme/DarkMode';
import '@material/web/iconbutton/standard-icon-button.js';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import PermDeviceInformationOutlinedIcon from '@mui/icons-material/PermDeviceInformationOutlined';
import EmojiObjectsOutlinedIcon from '@mui/icons-material/EmojiObjectsOutlined';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import ShowChartOutlinedIcon from '@mui/icons-material/ShowChartOutlined';
export const BurgerNavbar = ({ setDiplay }) => {

    const { t } = useTranslation();
    const navigate = useNavigate();
    const { theme } = React.useContext(ThemeContext);

    const content = [
        { id: 1, title: t('navbar.home'), hrefId: '#top', icon: <HomeOutlinedIcon sx={{ marginBottom: '-5px', marginRight: '5px', marginLeft: '5px' }} /> },
        { id: 2, title: t('navbar.why-Ahli'), hrefId: '#intro', icon: <HelpOutlineOutlinedIcon sx={{ marginBottom: '-7px', marginRight: '5px', marginLeft: '5px' }} /> },
        { id: 3, title: t('navbar.know-us'), hrefId: '#choseus', icon: <PermDeviceInformationOutlinedIcon sx={{ marginBottom: '-7px', marginRight: '5px', marginLeft: '5px' }} /> },
        { id: 4, title: t('navbar.Advantages'), hrefId: '#features', icon: <ShowChartOutlinedIcon sx={{ marginBottom: '-5px', marginRight: '5px', marginLeft: '5px' }}/> },
    ]

    const backToHome = () => {
        navigate('/')
        setDiplay(false)
    }

    const closeMnue = () => {
        setDiplay(false)
    }

    return (
        <div className={theme === 'light' ? 'responsive-menu' : 'light-responsive-menu'}>
            <md-standard-icon-button onClick={closeMnue}>
                <PlaylistRemoveIcon sx={{ cursor: 'pointer', color: theme === 'light' ? '#1c1b1e' : '#fffbff', width: '25px', height: '25px' }} />
            </md-standard-icon-button>
            {content.map(item => (
                <a onClick={backToHome} href={item.hrefId} key={item.id} className={theme === 'light' ? 'light-menu-responsive-list' : 'menu-responsive-list'} rel="nofollow">
                    <md-text-button className='menu-responsive-item'>
                        {item.icon}
                        {item.title}
                    </md-text-button>
                </a>
            ))}
            <NavLink onClick={closeMnue} to='/privacy' className={theme === 'light' ? 'light-menu-responsive-list' : 'menu-responsive-list'}>
                <md-text-button>
                    <MenuBookOutlinedIcon sx={{ marginBottom: '-5px', marginRight: '5px', marginLeft: '5px' }} />
                    {t('navbar.privacy')}
                </md-text-button>
            </NavLink>
            <NavLink onClick={closeMnue} to='/guide' className={theme === 'light' ? 'light-menu-responsive-list' : 'menu-responsive-list'}>
                <md-text-button>
                    <EmojiObjectsOutlinedIcon sx={{ marginBottom: '-5px', marginRight: '5px', marginLeft: '5px' }} />
                    {t('navbar.Guide')}
                </md-text-button>
            </NavLink>
        </div>
    )
}
